import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {CustomPageSection} from '../../../models/page-builder/custom-page-section.model';
import {filter} from 'rxjs/operators';


@Injectable({
  providedIn: 'root'
})
export class EditSectionService {

  private sectionIndex: number;

  private subject = new BehaviorSubject<{
    section: CustomPageSection,
    index: number
  }>(null);

  private dirty:boolean = false;

  sectionChanged$ = this.subject.asObservable()
    .pipe(
      filter(val => !!val)
    );

  setSectionIndex(index: number) {
    this.sectionIndex = index;
  }

  updateSection(section: CustomPageSection) {
    this.dirty = true;
    this.subject.next({
      section,
      index: this.sectionIndex
    });
  }

  isDirty() {
    return this.dirty;
  }

  pageSaved() {
    this.dirty = false;
  }

  setPageTouched() {
    this.dirty = true
  }

}
